/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestCheckDuplicateEmailAddressRequest
 */
export interface RequestCheckDuplicateEmailAddressRequest {
    /**
     * 
     * @type {string}
     * @memberof RequestCheckDuplicateEmailAddressRequest
     */
    mailAddress?: string;
}

/**
 * Check if a given object implements the RequestCheckDuplicateEmailAddressRequest interface.
 */
export function instanceOfRequestCheckDuplicateEmailAddressRequest(value: object): value is RequestCheckDuplicateEmailAddressRequest {
    return true;
}

export function RequestCheckDuplicateEmailAddressRequestFromJSON(json: any): RequestCheckDuplicateEmailAddressRequest {
    return RequestCheckDuplicateEmailAddressRequestFromJSONTyped(json, false);
}

export function RequestCheckDuplicateEmailAddressRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestCheckDuplicateEmailAddressRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'mailAddress': json['mail_address'] == null ? undefined : json['mail_address'],
    };
}

export function RequestCheckDuplicateEmailAddressRequestToJSON(json: any): RequestCheckDuplicateEmailAddressRequest {
    return RequestCheckDuplicateEmailAddressRequestToJSONTyped(json, false);
}

export function RequestCheckDuplicateEmailAddressRequestToJSONTyped(value?: RequestCheckDuplicateEmailAddressRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'mail_address': value['mailAddress'],
    };
}

